import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  accounts: null,

  accountsLoadingStatus: 'idle',

  selectedLogin: null,
  currency: '',

  statistics: {
    id: null,
    balance: null,
    type: null,

    clicks: null,
    registrations: null,
    approved: null,
    real_accounts: null,

    reward: null,

    transactions: null,
  },

  commissions: {
    total_deposits: null,
    total_withdrawals: null,
    total_commission: null,
    total_trading_volume: null,

    referrals: null,
  },

  referral: {
    name: null,
    status: null,

    id: null,
    login: null,
    level: null,
    last_activity: null,
    date_registration: null,

    total_deposit: null,
    total_withdrawal: null,
    commission: null,
    trading_volume: null,

    transactions: null,
  },

  createAccStatus: '',
};

export const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setPartnerAccounts: (state, action) => {
      state.accounts = action.payload;
    },

    setPartnerAccountsLoadingStatus: (state, action) => {
      state.accountsLoadingStatus = action.payload;
    },

    setPartnerSelectedLogin: (state, action) => {
      state.selectedLogin = action.payload;
    },
    setPartnerCurrency: (state, action) => {
      state.currency = action.payload;
    },

    setPartnerId: (state, action) => {
      state.statistics.id = action.payload;
    },
    setPartnerBalance: (state, action) => {
      state.statistics.balance = action.payload;
    },
    setPartnerType: (state, action) => {
      state.statistics.type = action.payload;
    },

    setPartnerStatisticsClicks: (state, action) => {
      state.statistics.clicks = action.payload;
    },
    setPartnerStatisticsRegistrations: (state, action) => {
      state.statistics.registrations = action.payload;
    },
    setPartnerStatisticsApproved: (state, action) => {
      state.statistics.approved = action.payload;
    },
    setPartnerStatisticsOpened: (state, action) => {
      state.statistics.real_accounts = action.payload;
    },

    setPartnerReward: (state, action) => {
      state.statistics.reward = action.payload;
    },

    setPartnerTransactions: (state, action) => {
      state.statistics.transactions = action.payload;
    },

    setPartnerTotalDeposits: (state, action) => {
      state.commissions.total_deposits = action.payload;
    },
    setPartnerTotalWithdrawals: (state, action) => {
      state.commissions.total_withdrawals = action.payload;
    },
    setPartnerTotalCommissions: (state, action) => {
      state.commissions.total_commission = action.payload;
    },
    setPartnerTotalLots: (state, action) => {
      state.commissions.total_trading_volume = action.payload;
    },

    setPartnerReferrals: (state, action) => {
      state.commissions.referrals = action.payload;
    },

    setPartnerReferralName: (state, action) => {
      state.referral.name = action.payload;
    },
    setPartnerReferralStatus: (state, action) => {
      state.referral.status = action.payload;
    },

    setPartnerReferralId: (state, action) => {
      state.referral.id = action.payload;
    },
    setPartnerReferralLogin: (state, action) => {
      state.referral.login = action.payload;
    },
    setPartnerReferralLevel: (state, action) => {
      state.referral.level = action.payload;
    },
    setPartnerReferralLastActivity: (state, action) => {
      state.referral.last_activity = action.payload;
    },
    setPartnerReferralDateRegistration: (state, action) => {
      state.referral.date_registration = action.payload;
    },

    setPartnerReferralTotalDeposit: (state, action) => {
      state.referral.total_deposit = action.payload;
    },
    setPartnerReferralTotalWithdrawal: (state, action) => {
      state.referral.total_withdrawal = action.payload;
    },
    setPartnerReferralCommission: (state, action) => {
      state.referral.commission = action.payload;
    },
    setPartnerReferralTradingVolume: (state, action) => {
      state.referral.trading_volume = action.payload;
    },

    setPartnerReferralTransactions: (state, action) => {
      state.referral.transactions = action.payload;
    },

    setCreatePartnerAccStatus: (state, action) => {
      state.createAccStatus = action.payload;
    },

    resetPartner: () => initialState,
  },
});

export const {
  setPartnerAccounts,

  setPartnerAccountsLoadingStatus,

  setPartnerSelectedLogin,
  setPartnerCurrency,

  setPartnerId,
  setPartnerBalance,
  setPartnerType,

  setPartnerStatisticsClicks,
  setPartnerStatisticsRegistrations,
  setPartnerStatisticsApproved,
  setPartnerStatisticsOpened,

  setPartnerReward,

  setPartnerTransactions,

  setPartnerTotalDeposits,
  setPartnerTotalWithdrawals,
  setPartnerTotalCommissions,
  setPartnerTotalLots,

  setPartnerReferrals,

  setPartnerReferralName,
  setPartnerReferralStatus,
  setPartnerReferralId,
  setPartnerReferralLogin,
  setPartnerReferralLevel,
  setPartnerReferralLastActivity,
  setPartnerReferralDateRegistration,

  setPartnerReferralTotalDeposit,
  setPartnerReferralTotalWithdrawal,
  setPartnerReferralCommission,
  setPartnerReferralTradingVolume,

  setPartnerReferralTransactions,

  setCreatePartnerAccStatus,

  resetPartner,
} = partnerSlice.actions;

export default partnerSlice.reducer;
